import React from 'react'
import { Dropdown } from '@billes/components'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import {
  User,
  History,
  Logout,
  ShowStartPage,
  HideStartPage,
  Bubble
} from 'components/Icons'
import canOrder from 'utils/canOrder'
import getHost from 'utils/getHost'
import checkHaikom from 'utils/checkHaikom'
import { t } from '@billes/translator-client'

const UserSection = connect(
  {
    showStartPage: state`startPage.show`,
    onHideStartPage: signal`startPage.onHideStartPage`,
    onShowStartPage: signal`startPage.onShowStartPage`,
    user: state`app.user`,
    listType: state`node.listType`,
    setListType: signal`node.setListType`,
    loadMyOrderHistory: signal`orderHistory.loadMyOrderHistory`
  },
  ({
    showStartPage,
    onHideStartPage,
    onShowStartPage,
    user,
    listType,
    setListType,
    loadMyOrderHistory
  }) => {
    if (!user) {
      return null
    }
    const isHaikom = checkHaikom()

    let startPage = {
      icon: <HideStartPage />,
      label: t('bms.header.hideStartPage'),
      action: onHideStartPage
    }
    if (!showStartPage) {
      startPage = {
        icon: <ShowStartPage />,
        label: t('bms.header.showStartPage'),
        action: onShowStartPage
      }
    }

    const accountURL = `${getHost()}/account`

    const { firstname, lastname, group } = user
    let items = isHaikom
      ? []
      : [
          { icon: <User />, label: t('modules.myAccount'), link: accountURL },
          startPage
        ]
    if (canOrder(group) && !group.shared) {
      items.push({
        action: loadMyOrderHistory,
        icon: <History />,
        label: t('bms.header.myOrderHistory')
      })
    }
    items.push({
      icon: <Bubble />,
      action: setListType,
      label:
        listType === 'FOLDER'
          ? t('bms.header.hierarchicalView')
          : t('bms.header.normalView')
    })
    if (!isHaikom) {
      items.push({
        icon: <Logout />,
        label: t('modules.logOut'),
        link: `${accountURL}/logout`
      })
    }

    return (
      <div style={{ display: 'inline-block' }}>
        <Dropdown
          icon={<User />}
          label={t('modules.loggedInAs', { name: `${firstname} ${lastname}` })}
          items={items}
        />
      </div>
    )
  }
)

export default UserSection



// WEBPACK FOOTER //
// ./src/components/Header/userSection.js